<template>
    <div class="bg-mission-item rounded-lg my-8" data-cy="card_mission_survey">
        <div class="box-mission grid items-center relative" data-cy="btn_mission_survey_detail" @click="clickToDetail()">
            <div class="box-text p-4">
                <div class="font-bold text-18 text-a-white-ffffff pb-3">
                    {{dashboard.line1}}
                </div>
                <div class="w-28 bg-a-white-ffffff font-bold text-14 text-a-blue-2140a6 text-center rounded-sm py-2.5"
                 v-if="!isSurveySuccess">
                    {{ lbl.mission.survey }}
                </div>
                <div class="w-28 bg-a-gray-c4c4c4 font-bold text-14 text-a-white-ffffff text-center rounded-sm py-2.5"
                    v-else>
                    {{ lbl.mission.survey_success }}
                </div>
                <div class="font-medium text-12 text-a-yellow-ffca66 pt-1" v-if="isSurveySuccess">
                    {{ lbl.mission.play_win }}
                </div>
            </div>
            <div class="box-img absolute my-auto justify-self-end">
                <img :src="imgUrl()" />
            </div>
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ConfigManager from '@/config/ConfigManager.js';
//service
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';

export default {
    name: 'MissionSurvey',
    mixins: [LocaleMixin],
    props: {
        dashboard: { type: Object, required: true },
        index: { type: Number, required: true }
    },
    data: function(){
        return {
            isSurveySuccess: false,
        }
    },
    created: async function(){
        let survey = await this.getSurveyDetail();

        if(!survey.isConditionPass){
            this.isSurveySuccess = true;
        }
    },
    methods: {
        getSurveyDetail: function(){
            if(!this.dashboard.id) return;

            let campaignId = this.dashboard.id;
            let campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            return new Promise((resolve) => {
                BzbsCampaign.apiGetCampaignDetail(campaignConfig).subscribe((campaign) => {
                    // console.log('campaign', campaign)
                    resolve(campaign);
                }, (err) => {
                    this.errorApi(err);
                    console.log(err);
                    resolve(null);
                });
            });
        },
        clickToDetail: function(){
            if(this.isSurveySuccess) return;

            this.tracking.event('mission_survey', 'mission_survey', this.dashboard.id, null);
            this.$router.push('/mission/detailandcondition/survey/' + this.index);
        },
        imgUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/image/mission/img-survey.png`;
        },
    }

}
</script>
<style lang="scss" scoped>
.box-mission{
    min-height: 180px;

    .box-text{
        width: 55%;
    }
    .box-img{
        width: 45%;
    }
}
</style>
